// Chamadas do pipeline de licitações (actions `lic_*` em /comercial/licitacoes).
// Uma função por ação, todas devolvendo o corpo já aberto; o erro vem com a
// frase do servidor (`erroDe`), que é o que a tela mostra.
import axios from 'axios';
import { API_URL } from '../../../config';
import { getToken } from '../../../utils/auth';
import type { LicitacaoPipeline } from './saudeLicitacao';

async function post<T = any>(body: Record<string, any>): Promise<T> {
  const token = await getToken();
  const r = await axios.post(`${API_URL}/comercial/licitacoes`, body, { headers: { Authorization: token }, timeout: 25000 });
  return (r.data?.body ? JSON.parse(r.data.body) : r.data) as T;
}

export const erroDe = (e: any): string =>
  e?.response?.data?.error || e?.response?.data?.erro || e?.message || 'erro desconhecido';

export interface Vendedor { nome: string; email: string }

export const licApi = {
  pipeline: () => post<LicitacaoPipeline[]>({ action: 'lic_pipeline' }),
  avaliar: (id: number, responsavel_email?: string) =>
    post<LicitacaoPipeline>({ action: 'lic_avaliar', id, responsavel_email }),
  decidir: (id: number, participar: boolean, motivo?: string, responsavel_email?: string) =>
    post<LicitacaoPipeline>({ action: 'lic_decidir', id, participar, motivo, responsavel_email }),
  mover: (id: number, para: string, extra: Record<string, any> = {}) =>
    post<LicitacaoPipeline>({ action: 'lic_mover_etapa', id, para, ...extra }),
  /** Campos da ficha (responsável, datas, valor…) — a mesma action da lista de Oportunidades. */
  atualizar: (id: number, campos: Record<string, any>) => post({ action: 'atualizar', id, ...campos }),
  detalhe: (id: number) => post({ action: 'detalhe', id }),
  vendedores: async (): Promise<Vendedor[]> => {
    const token = await getToken();
    const r = await axios.get(`${API_URL}/comercial/vendedores`, { headers: { Authorization: token } });
    const d = r.data?.body ? JSON.parse(r.data.body) : r.data;
    return Array.isArray(d) ? d : (d?.vendedores || []);
  },
};
